import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Font } from "@react-pdf/renderer";
import brandDark from "assets/images/logo-ct-dark.png";
import brandWhite from "assets/images/logo-ct.png";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import Configurator from "components/Configurator";
import CustomAlert from "components/CustomAlert";
import HomeNavBar from "components/Navbars/HomeNavbar/homeNavbar";
import NotFoundPage from "components/Page404/NotFoundPage";
import PersistLogin from "components/PersistLogin";
import Sidenav from "components/Sidenav";
import GetUser from "components/getUser";
import {
  setMiniSidenav,
  setOpenConfigurator,
  useMaterialUIController,
} from "context";
import { useEffect, useState, Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import routes from "routes";
import { AlertState } from "states";
import RobotoRegular from "./assets/Fonts/Roboto/Roboto-Regular.ttf";
import ProtectedRoute from "./components/ProtectedRoute";
import useAuth from "./hooks/useAuth";
import Header from "./components/Header";
import { DataProvinceState } from "states";
import { API_ROUTES } from "./utils/constants";
import axios from "axios";
import { DataNationState } from "states";
import { DataCountryState } from "states";
import { DataTypeOwnerState } from "states";
import { DataStatusState } from "states";
import { SettingState } from "states";
import GetBoTieuChi from "components/GetBoTieuChi";
import BoxLoading from "components/BoxLoading/boxLoading";

// Register the font outside the component
Font.register({
  family: "RobotoRegular",
  src: RobotoRegular,
});

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    openConfigurator,
    sidenavColor,
    homePage,
    whiteSidenav,
    transparentSidenav,
    darkMode,
    layout,
    anotherPage,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [alert, setAlert] = useRecoilState(AlertState);
  const { accessToken, user, statusAuth } = useAuth();

  const setOptionProvince = useSetRecoilState(DataProvinceState);
  const setOptionNation = useSetRecoilState(DataNationState);
  const setOptionCountry = useSetRecoilState(DataCountryState);
  const setOptionTypeOwner = useSetRecoilState(DataTypeOwnerState);
  const setOptionStatus = useSetRecoilState(DataStatusState);
  const setOptionSetting = useSetRecoilState(SettingState);

  const { pathname } = useLocation();
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };
  const handleCloseAlert = () => {
    setAlert({ alert: false, message: null, type: null });
  };
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  function flattenItems(array) {
    const flattenedArray = [];
    array.forEach((item) => {
      if (item.collapse) {
        flattenedArray.push({ ...item, collapse: [] });
        flattenedArray.push(...flattenItems(item.collapse));
      } else {
        flattenedArray.push({ ...item });
      }
    });
    // console.log(flattenedArray);
    return flattenedArray;
  }

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.collapse && route.collapse.length > 0) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={
              <ProtectedRoute access={route.access} permission={route?.key}>
                {route.component}
              </ProtectedRoute>
            }
            key={route.key + "routeApp"}
          />
        );
      }
      return null;
    });
  };

  useEffect(() => {
    const getAllDataProvince = async () => {
      try {
        const response = await axios.get(API_ROUTES.TINH);
        setOptionProvince(response?.data);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        return;
      }
    };
    const getAllDataNatiton = async () => {
      try {
        const response = await axios.get(API_ROUTES.DANTOC);
        setOptionNation(response?.data);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        return;
      }
    };
    const getAllDataCountry = async () => {
      try {
        const response = await axios.get(API_ROUTES.QUOCGIA);
        setOptionCountry(response?.data);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        return;
      }
    };
    const getAllDataTypeOwner = async () => {
      try {
        const response = await axios.get(API_ROUTES.LOAIHINH);
        setOptionTypeOwner(response?.data);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        return;
      }
    };
    const getAllDataStatus = async () => {
      try {
        const response = await axios.get(API_ROUTES.TRANGTHAI);
        setOptionStatus(response?.data);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        return;
      }
    };
    const getAllDataSetting = async () => {
      try {
        const response = await axios.get(API_ROUTES.SETTING + "/1");
        setOptionSetting(response?.data);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        return;
      }
    };
    getAllDataProvince();
    getAllDataNatiton();
    getAllDataCountry();
    getAllDataTypeOwner();
    getAllDataStatus();
    getAllDataSetting();
  }, []);
  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      <CustomAlert alert={alert} onClose={handleCloseAlert} />
      {!homePage && !anotherPage && layout != "page" && (
        <>
          <GetBoTieuChi />
          <GetUser />
          <Sidenav
            color={sidenavColor}
            brand={
              (transparentSidenav && !darkMode) || whiteSidenav
                ? brandDark
                : brandWhite
            }
            brandName="PHẦN MỀM ĐÁNH GIÁ LƯU TRỮ HỒ SƠ OCOP"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {/* {configsButton} */}
        </>
      )}
      {anotherPage && <Header />}
      <Suspense fallback={<BoxLoading />}>
        <Routes>
          <Route path="/" element={<PersistLogin />}>
            {getRoutes(flattenItems(routes))}
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}
